import { useContext, useEffect, useLayoutEffect } from "react";
import { Link, Route, Routes,  useNavigate } from "react-router-dom";
import DairyLayout from "./Diarys/DiarysLayout";
import SiteLayout from "./Site/SiteLayout";
import "./Colors.scss";
import "./FontMultiplier.scss";
import "./App.scss";
import ThemeControl from "./CommonComponents/ThemeControl/ThemeControl";
import { AppContext } from "./Context/AppContext";
import HealthLayout from "./Health/HealthLayout"
import MessengerLayout from "./Messenger/MessengerLayout"
import RecognitionLayout from "./recognitionText/RecognitionLayout";
import UploaderLayout from "./FileUploader/UploaderLayout"
import { useWebSocket } from "./useWebSocket";
import MainGate from "./AITextAnalyse";
// import MessengerNewLayout from "./Messenger-new/MessengerLayout"

function App(props) {
	const {connection, setTheme} = useContext(AppContext);
	useLayoutEffect(() => {
		setTheme(prev => ({
			...prev,
			...props.initTheme
		}))
	},[])
	useEffect(() =>{
		if(connection){
			connection.onopen = async function () {
				connection.send(
					JSON.stringify({action: "getKeyValue", key: "color"})
				)	
			};			
		}
	},[connection?.readyState ])
	
	return (
		<div>
			<Routes>
				<Route index element={<SiteLayout/>} />
				<Route path='/dairys' element={<DairyLayout />} />
				<Route path='/site' element={<SiteLayout/>} />
				<Route path='/health' element={<HealthLayout/>} />
				<Route path='/messenger' element={<MessengerLayout/>} />
				<Route path='/recognitionText' element={<RecognitionLayout />} />
				<Route path='/uploader' element={<UploaderLayout />} />
				<Route path='/aigate' element={<MainGate />} />
				{/* <Route path='/messengerNew' element={<MessengerNewLayout />} /> */}
				<Route path='*' element={<SiteLayout/>} />
			</Routes>
		</div>
	);
}

export function HomeMenu(props) {
	const {theme} = useContext(AppContext)
	const navigate = useNavigate();
	return (
			<div
				className='main-container'
				style={{
					fontSize: `${(16 / theme.scaleFactor) * theme.fontMultiplier}px`,
				}}
				color={theme.color}
				fontmultiplier={theme.fontMultiplier}
			>
				<div className='head'>
					<div className='navigation-header'>
						
					</div>
					<div className='content-header'>
		
					</div>
					<div className='support-header'>
						<ThemeControl />
					</div>
				</div>
				<div className='body'>
					<div className='navigation-column'>
						<div className='navigation'>
							
						</div>
					</div>
					<div className='content-column'>
						<div className='menu'>
							<Link className="menu-button" to={"/dairys"} state={{isNew: 1}} target="_blank">Дневники<span>{`→`}</span></Link>
							{/* <div
								className='menu-button'
								onClick={() => {
									navigate("/dairys", {state:{isNew: 1}});
								}}
							>
								Дневники
							</div> */}
							<Link className="menu-button" to={"/site"} target="_blank">Сайт<span>{`→`}</span></Link>

							{/* <div
								className='menu-button'
								onClick={() => {
									navigate("/site");
								}}
							>
								Сайт
							</div> */}
							<Link className="menu-button" to={"/dairys?isNew=0"} state={{isNew: 0}} target="_blank">Заметки<span>{`→`}</span></Link>
							{/* <div
								className='menu-button'
								onClick={() => {
									navigate("/dairys", {state:{isNew: 0}});
								}}
							>
								Заметки
							</div> */}
							<div
								className='menu-button'
								onClick={() => {
									navigate("/health");
								}}
							>
								Данные по анализам<span>{`→`}</span>
							</div>
							<div
								className='menu-button'
								onClick={() => {
									navigate("/uploader");
								}}
							>
								Загрузка файлов<span>{`→`}</span>
							</div>
							{/* <div
								className='menu-button'
								onClick={() => {
									navigate("/messenger");
								}}
							>
								Мессенджер<span>{`→`}</span>
							</div> */}
							<a
								className='menu-button'
								href="http://172.22.10.14:5005" target="_blank"
							>
								Дневник здоровья<span>{`→`}</span>
							</a>
							<div
								className='menu-button'
								onClick={() => {
									navigate("/");
								}}
							>
								Вес<span>{`→`}</span>
							</div>
							<div
								className='menu-button'
								onClick={() => {
									navigate("/");
								}}
							>
								Погода<span>{`→`}</span>
							</div>
							<div
								className='menu-button'
								onClick={() => {
									navigate("/recognitionText");
								}}
							>
								Распознавание текста<span>{`→`}</span>
							</div>
							{/* <div
								className='menu-button'
								onClick={() => {
									navigate("/messengerNew");
								}}
							>
								Новый мессенджер
							</div> */}
					</div>
					</div>
					<div className='support-column'>
					</div>
				</div>
				{/* <div className='footer'>
					<div className='navigation-footer'></div>
					<div className='content-footer'></div>
					<div className='support-footer'></div>
				</div> */}
			</div>

	);
}

export default App;
